// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#stawag-leads-form .helper-text{font-size:95%}#stawag-leads-form .helper-text p:last-child{margin-bottom:0!important}#stawag-leads-form .helper-text img{max-width:100%;height:auto;vertical-align:middle;border-radius:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
